import request from '@/utils/request'

let LotteryApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/getlottery', data, errorback);
  },
  /*编辑*/
  EditLottery(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/setting', data, errorback);
  },
  /*列表*/
  recordList(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/record', data, errorback);
  },
  /*列表*/
  recordList(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/record', data, errorback);
  },
  getAward(data, errorback) {
    return request._post('/shop/plus.lottery.lottery/award', data, errorback);
  },
}

export default LotteryApi;



// WEBPACK FOOTER //
// ./src/api/lottery.js